import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Classes, DISPLAYNAME_PREFIX } from "../../common";

const colWidths = ["xs", "sm", "md", "lg", "xl"];
const stringOrNumberProp = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);

const columnProps = PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.number,
    PropTypes.string,
    PropTypes.shape({
        size: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
        order: stringOrNumberProp,
        offset: stringOrNumberProp,
    }),
]);

const propTypes = {
    //tag: tagPropType,
    xs: columnProps,
    sm: columnProps,
    md: columnProps,
    lg: columnProps,
    xl: columnProps,
    className: PropTypes.string,
    cssModule: PropTypes.object,
    widths: PropTypes.array,
};

const defaultProps = {
    //tag: "div",
    widths: colWidths,
};

const getColumnSizeClass = (isXs: boolean, colWidth: string | number | boolean, colSize: string | number | boolean) => {
    if (colSize === true || colSize === "") {
        return isXs ? Classes.GRID_COL : `${Classes.GRID_COL}-${colWidth}`;
    } else if (colSize === "auto") {
        return isXs ? `${Classes.GRID_COL}-auto` : `${Classes.GRID_COL}-${colWidth}-auto`;
    }

    return isXs ? `${Classes.GRID_COL}-${colSize}` : `${Classes.GRID_COL}-${colWidth}-${colSize}`;
};
type ColumnType =
    | boolean
    | number
    | string
    | { size?: number | boolean | string; order?: string | number; offset?: string | number };

type Props = {
    //tag: tagPropType,
    xs?: ColumnType;
    sm?: ColumnType;
    md?: ColumnType;
    lg?: ColumnType;
    xl?: ColumnType;
    className?: string;
    //cssModule: object;
    widths?: string[];
    [key: string]: any;
};

const Col = (props: Props) => {
    const { className, widths = [], /*tag: Tag,*/ ...attributes } = props;
    const colClasses = [];

    widths.forEach((colWidth, i) => {
        let columnProp = props[colWidth];

        delete attributes[colWidth];

        if (!columnProp && columnProp !== "") {
            return;
        }

        const isXs = !i;

        if (typeof columnProp === "object") {
            const colSizeInterfix = isXs ? "-" : `-${colWidth}-`;
            const colClass = getColumnSizeClass(isXs, colWidth, columnProp.size!);

            colClasses.push(
                classNames({
                    [colClass]: columnProp.size || columnProp.size === "",
                    [`order${colSizeInterfix}${columnProp.order}`]: columnProp.order || columnProp.order === 0,
                    [`offset${colSizeInterfix}${columnProp.offset}`]: columnProp.offset || columnProp.offset === 0,
                }),
            );
        } else {
            const colClass = getColumnSizeClass(isXs, colWidth, columnProp);
            colClasses.push(colClass);
        }
    });

    if (!colClasses.length) {
        colClasses.push(Classes.GRID_COL);
    }

    const classes = classNames(className, colClasses);

    return <div {...attributes} className={classes} />;
    //return <Tag {...attributes} className={classes} />;
};

Col.propTypes = propTypes;
Col.defaultProps = defaultProps;
Col.displayName = `${DISPLAYNAME_PREFIX}.Col`;

export { Col };
